import { Box, Button, Stack, Typography } from "@mui/material";

import styled from "styled-components";

import { isMobile, isSmallDesktop } from "@/hooks/layout";

export const CopyrightProtectedStack = styled(Stack)`
  width: 100%;
  background: rgba(75, 55, 39, 0.5);

  border-radius: 8px;

  position: relative;

  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
    height: 16px;
    opacity: 0.3;
    margin: 6px 0 0;
    transition: opacity 0.3s ease-in-out;
    cursor: pointer;

    ${isSmallDesktop} {
      width: 18px;
      height: 18px;
      margin: 18px;
    }
  }

  .close:hover {
    opacity: 1;
  }

  .close:before,
  .close:after {
    position: absolute;
    content: "";
    height: 16px;
    width: 2px;
    background-color: #ffdca8;

    ${isSmallDesktop} {
      height: 24px;
    }
  }

  .close:before {
    transform: rotate(45deg);
  }

  .close:after {
    transform: rotate(-45deg);
  }
`;

export const CopyrightProtectedTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.textColor.common};
  font-family: Raleway;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  text-align: center;

  ${isSmallDesktop} {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;

export const SelectStack = styled(Stack)`
  min-width: 202px;
  width: 100%;

  border-right: 4px;
`;

export const SortTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.textColor.common};
  font-family: Raleway;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.0875rem;
  text-transform: capitalize;
  white-space: nowrap;
`;

export const SortButton = styled(Button)`
  min-height: 40px;
  min-width: 40px;
  padding: 0;
`;

export const MobileAlbumStack = styled(Stack)`
  border-radius: 8px;
  border: ${({ theme }) => `2px solid ${theme.palette.borderColors.iconButton}`};
  background-color: rgba(75, 55, 39, 0.8);
`;

// System UI font for numeric values (durations, counts, badges, pagination)
export const NumericText = styled.span`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
    sans-serif;
`;

export const AvailableForTagWrapper = styled(Box)<{ isDesktop: boolean }>`
  height: 36px;
  border-radius: ${({ isDesktop }) => (isDesktop ? "64px" : "8px")};
  background-color: rgba(75, 55, 39, 0.8);
  transition: background-color 300ms ease-in-out;
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: rgba(75, 55, 39, 1);
  }

  ${isMobile} {
    border: 1px solid #886c55;
  }
`;
